import { useTranslation } from 'react-i18next'

import { useTimeZone } from '../../../../../hooks'
import { FieldStackedLabel } from '../../../../Field'
import Text from '../../../../Text'
import { QA_NAME_CALENDAR_TASK_MOVE_PREVIOUS_DEADLINE } from '../../CalendarTaskMoveModal.constants'

import { formatCalendarTaskMoveDeadline } from './PreviousDeadline.utils'

function PreviousDeadline({ deadline }) {
  const { t } = useTranslation()

  const timezone = useTimeZone()

  return (
    <FieldStackedLabel label={t('Calendar.MoveDueBeforeKey')}>
      <Text qaName={QA_NAME_CALENDAR_TASK_MOVE_PREVIOUS_DEADLINE}>
        {formatCalendarTaskMoveDeadline({ deadline, timezone })}
      </Text>
    </FieldStackedLabel>
  )
}

export default PreviousDeadline
